import { useEffect, useState } from 'react';
import { useStore } from '../state/store';

/**
 * Milliseconds left on the current phase timer, counted on this phone's own
 * clock from when the server's last update arrived.
 */
export function useCountdown(): number | null {
  const timer = useStore((s) => s.view?.timer ?? null);
  const receivedAt = useStore((s) => s.viewReceivedAt);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    setNow(Date.now());
    if (!timer || timer.paused) return;
    const id = window.setInterval(() => setNow(Date.now()), 250);
    return () => window.clearInterval(id);
  }, [timer, receivedAt]);

  if (!timer) return null;
  return timer.paused ? timer.remainingMs : Math.max(0, timer.remainingMs - (now - receivedAt));
}
